import { render, staticRenderFns } from "./CalculationSettings.vue?vue&type=template&id=29fa217c&"
import script from "./CalculationSettings.vue?vue&type=script&lang=js&"
export * from "./CalculationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports